import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
type FindSimilarIconProps = SVGProps<SVGSVGElement> & {
  size?: number | string;
};
export function FindSimilarIcon(t0) {
  const $ = _c(9);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M15.8312 17.4978L12.2062 13.8728M13.9546 10.8312C13.2145 13.7066 10.6043 15.8312 7.49792 15.8312C3.81602 15.8312 0.83125 12.8464 0.83125 9.16451C0.83125 6.05812 2.95587 3.44795 5.83125 2.70788M9.79888 7.58121C9.75425 7.40817 9.66406 7.25027 9.5377 7.12391C9.41134 6.99755 9.25343 6.90736 9.0804 6.86272L6.01298 6.07174C5.96065 6.05689 5.91459 6.02537 5.88179 5.98197C5.849 5.93857 5.83125 5.88565 5.83125 5.83125C5.83125 5.77685 5.849 5.72393 5.88179 5.68053C5.91459 5.63713 5.96065 5.60561 6.01298 5.59076L9.0804 4.79928C9.25337 4.75468 9.41124 4.66457 9.53759 4.5383C9.66394 4.41204 9.75417 4.25423 9.79888 4.08129L10.5899 1.01387C10.6046 0.96133 10.6361 0.915043 10.6795 0.882071C10.723 0.849098 10.776 0.83125 10.8306 0.83125C10.8852 0.83125 10.9382 0.849098 10.9817 0.882071C11.0252 0.915043 11.0566 0.96133 11.0713 1.01387L11.8618 4.08129C11.9065 4.25433 11.9967 4.41223 12.123 4.53859C12.2494 4.66495 12.4073 4.75514 12.5803 4.79978L15.6477 5.59026C15.7005 5.60481 15.747 5.63626 15.7801 5.67979C15.8133 5.72332 15.8312 5.77653 15.8312 5.83125C15.8312 5.88597 15.8133 5.93917 15.7801 5.98271C15.747 6.02624 15.7005 6.05769 15.6477 6.07224L12.5803 6.86272C12.4073 6.90736 12.2494 6.99755 12.123 7.12391C11.9967 7.25027 11.9065 7.40817 11.8618 7.58121L11.0709 10.6486C11.0561 10.7012 11.0247 10.7475 10.9812 10.7804C10.9377 10.8134 10.8847 10.8312 10.8301 10.8312C10.7755 10.8312 10.7225 10.8134 10.679 10.7804C10.6356 10.7475 10.6041 10.7012 10.5894 10.6486L9.79888 7.58121Z" transform="translate(1.091 0) scale(1.3094)" strokeWidth="1.5274" vectorEffect="non-scaling-stroke" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== className || $[6] !== props || $[7] !== size) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" className={className} {...props}>{t2}</svg>;
    $[5] = className;
    $[6] = props;
    $[7] = size;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}